import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import Navbar from '../../components/Navbar';

const PasswordReset = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      if (response.ok) {
        setSent(true);
      } else {
        // Even on error, show success to prevent email enumeration
        setSent(true);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      // Still show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br bg-[#F4F2F2]">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="pt-24 pb-12 px-4">
        <div className="max-w-md mx-auto">
          <button
            onClick={() => navigate('/login')}
            className="flex items-center gap-2 text-gray-600 hover:text-[#2B2142] mb-8"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück zum Login
          </button>

          <div className="bg-white rounded-3xl shadow-xl p-8">
            {!sent ? (
              <>
                <div className="text-center mb-8">
                  <div className="w-16 h-16 bg-[#FFF0D1] rounded-full flex items-center justify-center mx-auto mb-4">
                    <Mail className="w-8 h-8 text-[#2B2142]" />
                  </div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">Passwort vergessen?</h1>
                  <p className="text-gray-600">Kein Problem! Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      E-Mail-Adresse
                    </label>
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#2B2142] focus:outline-none"
                      placeholder="deine@email.de"
                      data-testid="reset-email-input"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-4 bg-[#2B2142] hover:bg-[#1E1730] text-white font-semibold rounded-xl disabled:opacity-50 transition-colors"
                    data-testid="reset-submit-btn"
                  >
                    {loading ? 'Wird gesendet...' : 'Zurücksetzen-Link senden'}
                  </button>
                </form>
              </>
            ) : (
              <div className="text-center" data-testid="reset-success">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">E-Mail versendet!</h2>
                <p className="text-gray-600 mb-6">
                  Wenn zu dieser E-Mail-Adresse ein Account existiert, haben wir dir einen Link zum Zurücksetzen deines Passworts geschickt.
                </p>
                <p className="text-sm text-gray-500 mb-8">
                  Überprüfe auch deinen Spam-Ordner, falls die E-Mail nicht in deinem Posteingang ankommt.
                </p>
                <button
                  onClick={() => navigate('/login')}
                  className="px-6 py-3 bg-[#2B2142] hover:bg-[#1E1730] text-white font-semibold rounded-xl"
                >
                  Zurück zum Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
